import request from 'lib/request';
import { Response } from 'lib/request/types';

type StructureGridResultItem = {
  id: number;
  basinName: string;
  geologicInterval: string;
  gridSurface: string;
  gridProcessed: boolean;
  owner: string;
  source: string;
  validity: string;
  status: string;
};

type StructureGridUnpaginatedResponse = {
  results: StructureGridResultItem[];
  totalCount: number;
};

export const VALIDITY_OPTIONS = [
  'All',
  'incomplete',
  'invalid',
  'valid',
  'warning',
];

export const PROCESSING_OPTIONS = [
  'All',
  'created',
  'processing',
  'processed',
  'failed',
];

export default async function getFilterOptions() {
  const response = await request.post<
    StructureGridUnpaginatedResponse,
    Response<{ errors: { [key: string]: string[] } }>
  >(
    '/queries/structure_grids',
    {
      query: {
        paginated: false,
      },
    },
    new AbortController()
  );

  if (response.type === 'success') {
    const data = response.data;
    return {
      basins: getDistinctValuesFromResponse(data, 'basinName'),
      geologicIntervals: getDistinctValuesFromResponse(
        data,
        'geologicInterval'
      ),
      dataOwners: getDistinctValuesFromResponse(data, 'owner'),
      dataSources: getDistinctValuesFromResponse(data, 'source'),
      validity: getDistinctValuesFromResponse(data, 'validity'),
      status: getDistinctValuesFromResponse(data, 'status'),
    };
  } else {
    return {
      basins: [],
      geologicIntervals: [],
      dataOwners: [],
      dataSources: [],
    };
  }
}

function getDistinctValuesFromResponse(
  data: StructureGridUnpaginatedResponse,
  field:
    | 'basinName'
    | 'geologicInterval'
    | 'owner'
    | 'source'
    | 'validity'
    | 'status'
) {
  const result = new Set<string>();
  data.results.forEach((item: StructureGridResultItem) => {
    result.add(item[field]);
  });
  return Array.from(result).sort();
}
